<template>
  <div class="con-layout">
    <header class="con-header">
      <Button
        type="icon"
        @click="goback"
      >
        <i class="cmlist-icon-back icon-back-screen" />
      </Button>
    </header>
    <container>
      <Tabs
        :tabsList="tabsList"
        @changeTabs="changeTabs"
      ></Tabs>
      <div
        id="tab-wrapper"
        class="tab-wrapper tab-wrapper-screen"
      >
        <Part
          v-for="(item, index) in tabList"
          :key="index"
          :name="item.name"
          :desc="item.desc"
          :itemList="item.resultList"
          @click="handlUrl"
        ></Part>
      </div>
    </container>
  </div>
</template>

<script>
import { getQueryStringArgs } from '../../utils/query-string';
import Button from '../Button.vue';
import Container from './Container.vue';
import Tabs from './Tabs.vue';
import Part from './Part.vue';
import { getCMlist } from '../../request/cm-ser';
import comUrl from '../../utils/uri';
import { sAtob } from '../../utils/base64';
import {clearUserinfo} from '../../request/userinfo';

export default {
  name: 'index',

  components: {
    Button,
    Container,
    Tabs,
    Part,
  },

  data() {
    return {
      tabsList: [],
      tabList: [],
      tabId: null,
      fr: null,
    };
  },

  methods: {
    handlUrl(p) {
      const { projectId } = p;
      this.$router.push({
        path: '/codemonkey',
        query: {
          projectId,
        },
      });
    },

    async getCMlist() {
      try {
        const { data } = await getCMlist({
          categoryDivideId: this.tabId,
        });
        this.tabList = data.data;
        this.scrollToTop();
      } catch (error) {
        console.log('error:', error);
      }
    },

    goback() {
      switch (this.fr) {
        case '0':
          window.location.href = comUrl.frTeaUrl;
          break;
        case '1':
          window.location.href = comUrl.frStuUrl;
          break;
        default:
          clearUserinfo();
          this.$router.push({ path: '/login' });
      }
    },

    changeTabs(id) {
      this.tabId = id;
      this.getCMlist();
    },

    scrollToTop() {
      const dom = document.getElementById('tab-wrapper');
      dom.scrollTop = 0;
    },
  },

  created() {
    const { tabs, ctId = '1' } = this.$route.query;
    const { fr } = getQueryStringArgs(window.location.search);
    this.tabsList = JSON.parse(sAtob(tabs));
    this.tabId = ctId;
    this.fr = fr;
    this.getCMlist();
  },
};
</script>

<style lang='less' scoped>
@import '../../assets/styles/mixins.less';

.con-layout {
  width: 100%;
  height: 100vh;
  padding: 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .bg-img('../../assets/images/cmlist/green_bg');
  background-size: cover;

  .tab-wrapper {
    width: 100%;
    min-height: 300px;
    overflow: auto;
  }
}
</style>
